import { useState, useEffect, useContext } from 'react';
import { UserDataContext } from '../context/UserContext';
import { fetchCollectorProfile, fetchActiveDuty } from '../utils/api';
import StartYourMission from '../components/DutyScreens/StartYourMission';
import StartMission from '../components/DutyScreens/StartMission';
import MissionisLive from '../components/DutyScreens/MissionisLive';
import MissionDetails from '../components/DutyScreens/MissionDetails';
import Qcform from '../components/QcComponents/Qcform';
import SubmissionSuccess from '../components/DutyScreens/SubmissionSuccess';

const CollectorsHome = () => {
    const { setUser } = useContext(UserDataContext);
    const [view, setView] = useState('loading'); // 'loading', 'landing', 'camera', 'live', 'details'
    const [loading, setLoading] = useState(true);

    const loadState = async () => {
        try {
            setLoading(true);
            const profileRes = await fetchCollectorProfile();
            const profile = profileRes.data || profileRes;

            // Sync fresh profile data to UserContext
            setUser(prev => ({ ...prev, ...profile, role: 'COLLECTOR', authenticated: true }));

            const activeDutyId = profile.active_duty_id;
            const isQcPending = localStorage.getItem('qc_pending') === 'true';

            // Ensure active_duty_id is persisted in localStorage
            if (activeDutyId) {
                localStorage.setItem('active_duty_id', activeDutyId);
            } else {
                // Only clear if not in pending QC state (to preserve ID for QC form)
                if (!isQcPending) {
                    localStorage.removeItem('active_duty_id');
                }
            }

            if (!activeDutyId) {
                if (isQcPending) {
                    setView('qc');
                } else {
                    setView('landing');
                }
            } else {
                const dutyRes = await fetchActiveDuty(profile.collectorsId);
                const duty = dutyRes.data || dutyRes;

                if (!duty.stop_time) {
                    setView('live');
                } else {
                    if (isQcPending) {
                        setView('qc');
                    } else {
                        setView('landing');
                    }
                }
            }
        } catch (error) {
            console.error('Error loading collector state:', error);
            setView('landing');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadState();
    }, []);

    const handleStartClick = () => setView('camera');
    const handleMissionStarted = () => loadState();
    const handleStopMission = () => setView('details');
    const handleMissionDetailsSubmitted = () => setView('qc');
    const handleQcSuccess = () => setView('success');

    const handleSuccessComplete = () => {
        loadState();
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-white">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00BFA5]"></div>
            </div>
        );
    }

    return (
        <>
            {view === 'landing' && <StartYourMission onStartClick={handleStartClick} />}
            {view === 'camera' && <StartMission onMissionStarted={handleMissionStarted} />}
            {view === 'live' && <MissionisLive onStopMission={handleStopMission} />}
            {view === 'details' && <MissionDetails onMissionsSubmitted={handleMissionDetailsSubmitted} />}
            {view === 'qc' && <Qcform onSuccess={handleQcSuccess} />}
            {view === 'success' && <SubmissionSuccess onComplete={handleSuccessComplete} />}
        </>
    );
};

export default CollectorsHome;
